import { LitEntity, html } from '../../utility/lit-entity';
import '../../common/bn-icon';

class NotificationsActiveCount extends LitEntity {
  static get properties() {
    return {
      maxcount: { type: Number },
      count: { type: Number, reflect: true },
    };
  }

  render() {
    if (!this.entity) {
      return html`<bn-icon name="fas fa-spinner fa-pulse"></bn-icon>`;
    }
    return html`${this.count}`;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!entity) {
      return;
    }
    const activeCount = this.entity.entities.filter((entity) => !entity.properties.read).length;
    this.count = Math.min(activeCount, this.maxcount || activeCount);
  }
}

window.customElements.define('notifications-active-count', NotificationsActiveCount);
